/**
 * The refused-request card above the composer: the catalogue sentence, and
 * under it the turn's reference — its `X-Trace-Id` — when there is one.
 *
 * **What reaches this card narrowed when errors moved into the flow** (#58 item
 * 4). A failure that belongs to a turn now renders on that turn's reply, where
 * the steps it interrupted are; what is left here is the refusal raised *before*
 * any turn began — not signed in — which has no message to attach to and would
 * otherwise have nowhere to appear at all.
 *
 * The reference line is shared with the in-flow card (`TraceReference`).
 */
import type { ChatError } from "../../hooks/useChatTurn";
import { TraceReference } from "./TraceReference";

export function ComposerError({ error }: { error: ChatError }) {
  return (
    <div className="composer-error" role="alert">
      <p className="composer-error-text">{error.text}</p>
      {error.traceId ? <TraceReference traceId={error.traceId} className="composer-error-ref" /> : null}
    </div>
  );
}
